import React, { Component } from 'react';

import classes from './Legend.module.css';
import LayerGroup from '../../components/LayerGroup/LayerGroup';

class Legend extends Component {

    render () {

        let fireItems = [];

        for (let i = 5; i < this.props.legendItems.length; i++) {
            fireItems.push(this.props.legendItems[i])
        }

        return(
            <div className={classes.LegendWrapper}>
                <div className={classes.LayerGroups}>

                    <LayerGroup 
                        legendItems={fireItems} 
                        groupName="Πυρκαγιές"
                        icon="fireIcon"  
                    />

                    <LayerGroup 
                        legendItems={[this.props.legendItems[0],this.props.legendItems[1],this.props.legendItems[2],this.props.legendItems[3]]}
                        groupName="Διοικητικές ενότητες"
                        icon="admIcon"
                    />

                    <LayerGroup 
                        legendItems={this.props.legendItems[4]} 
                        groupName="Χρήσεις γης"
                        icon="clcIcon"
                    />
                </div>
            </div>
        )
    }
}

export default Legend;